import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends ComponentProps<'input'> {
  /** Renders the error border from the palette's red. */
  invalid?: boolean;
}

export function Input({ className, invalid, ...props }: InputProps) {
  return (
    <input
      aria-invalid={invalid || undefined}
      className={cn(
        'w-full rounded-control border bg-card px-3 py-2.5 text-row text-fg placeholder:text-fg-hint',
        'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent',
        invalid ? 'border-cal-9' : 'border-line',
        className,
      )}
      {...props}
    />
  );
}
